import TagManager from 'react-gtm-module'

import Clarity from '@microsoft/clarity'

import { YANADOO_CLARITY_ID, YANADOO_GTM_ID } from 'common/config'

import { checkIpAddress } from '../utils/ipCheck'

// GTM dataLayer 초기화
export const initializeDataLayer = () => {
  if (!window.dataLayer) {
    window.dataLayer = []
  }
}

// 분석 도구 초기화
export const initializeAnalytics = async () => {
  const isProduction = process.env.NODE_ENV === 'production'

  // dataLayer는 항상 초기화
  initializeDataLayer()

  try {
    // IP 체크 및 분석 도구 초기화
    const { isBlocked, excludedIp } = await checkIpAddress()

    if (isProduction && !isBlocked && excludedIp === 'N') {
      TagManager.initialize({ gtmId: YANADOO_GTM_ID })
      Clarity.init(YANADOO_CLARITY_ID)
    }
  } catch (error) {
    console.error('Analytics initialization failed:', error)
  }
}
